import { auth } from '../firebase';

/** 로그인된 계정의 Firebase ID 토큰. 없으면 헤더를 비워 옛 화면과 같게 보낸다. */
export async function bearerHeaders(extra = {}) {
  const headers = { 'Content-Type': 'application/json', ...extra };
  try {
    if (auth.currentUser) {
      headers.Authorization = `Bearer ${await auth.currentUser.getIdToken()}`;
    }
  } catch (e) {
    // 토큰을 못 읽으면 서버 로그 모드가 요청을 그대로 처리한다.
  }
  return headers;
}
